import React from 'react';
import { IonAccordionGroup } from '@ionic/react';
import StoreBrandAccordion from './StoreBrandAccordion';
import StoreInfoAccordion from './StoreInfoAccordion';
import { FormProvider } from 'react-hook-form';
import useStoreService from '../../../../../../services/stores/hooks/useStoreServices';
import OfficialDocsAccordion from './OfficialDocsAccordion';

export default function StoreCreationForm() {
  const {
    handleSaveStoreInfo,
    methods,
    handleSaveStoreImage,
    handleSaveStoreOfficialDocs,
  } = useStoreService();

  return (
    <div className="space-y-4">
      <label className="font-medium high-emphasis-text">
        Store Information
      </label>
      <IonAccordionGroup className="border border-border rounded-md overflow-hidden">
        <FormProvider {...methods}>
          <form className="contents">
            <StoreInfoAccordion onSave={handleSaveStoreInfo} />
            {/* STORE LOGO AND BANNER */}
            <StoreBrandAccordion onSave={handleSaveStoreImage} />
            {/* USER OFFICIAL DOCUMENTATION */}
            <OfficialDocsAccordion onSave={handleSaveStoreOfficialDocs} />
          </form>
        </FormProvider>
        {/* <UserAddressAccordion /> */}
      </IonAccordionGroup>
    </div>
  );
}
